import { useState, useEffect } from 'react'
import './chat.css'

// Create a base URL constant at the top of your chat.jsx file
const API_URL = "https://your-app-name.herokuapp.com";

function Chat() {
    const [messages, setMessages] = useState([])
    const [userInput, setUserInput] = useState('')

    const deleteChatbox = async (index) => {
        try {
            const response = await fetch(`${API_URL}/delete`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    input: messages[index],
                    response: messages[index + 1]
                })
            })

            if (!response.ok) {
                throw new Error('Failed to delete message')
            }

            // Only update UI if backend deletion was successful
            setMessages(prev => prev.filter((_, i) => i !== index && i !== index + 1))
        } catch (error) {
            console.error('Error deleting message:', error)
            alert('Failed to delete message')
        }
    }

    async function getResponse(e) {
        e.preventDefault()
        try {
            if (!userInput.trim()) return
            
            // Get AI response
            const response = await fetch(`${API_URL}/chat`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({userInput})
            })
            
            if (!response.ok) {
                throw new Error('Failed to fetch response')
            }
            
            const data = await response.json()
            
            const saveResponse = await fetch(`${API_URL}/logs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    userInput: userInput,
                    response: data.message
                })
            })

            if (!saveResponse.ok) {
                console.error('Failed to save to database')
            }
            
            setMessages(prev => [...prev, userInput, data.message])
            setUserInput('')
        } catch (error) {
            console.error('Error details:', error)
            setMessages(prev => [...prev, userInput, 'Oops, something went wrong!'])
        }
    }

    useEffect(() => {
        fetch(`${API_URL}/logs`)
            .then(res => res.json())
            .then(data => {
                let newMessages = []
                for (let i = 0; i < data.logs.length; i ++) {
                    newMessages.push(data.logs[i].Input)
                    newMessages.push(data.logs[i].response)
                }
                setMessages(newMessages)
            })
            .catch(error => console.error('Error fetching logs:', error))
    }, [])

    return (
        <div id="chat">
            <div className="chat-container">
                <div className="chat-header">
                    <h2>Ask me a question!</h2>
                </div>
                
                <div className="messages-area">
                    {messages.length === 0 ? (
                        <div className="welcome-message">
                            <p>Hi there! Ask me anything to start our conversation.</p>
                        </div>
                    ) : (
                        messages.map((text, index) => (
                            <div key={index} className={index % 2 === 0 ? 'message user-message' : 'message bot-message'}>
                                {index % 2 === 0 && (
                                    <button className="x" onClick={() => deleteChatbox(index)}>
                                        ×
                                    </button>
                                )}
                                <div className="message-content">
                                    <span className="message-prefix">{index % 2 === 0 ? 'You: ' : 'AI: '}</span>
                                    {text}
                                </div>
                            </div>
                        ))
                    )}
                </div>
                
                <div className="input-area">
                    <form onSubmit={getResponse}>
                        <input
                            type="text"
                            value={userInput}
                            name="user-input"
                            id="questionInput"
                            placeholder="Type your question here..."
                            onChange={(e) => setUserInput(e.target.value)}
                        />
                        <button type="submit">Submit</button>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Chat